import React from "react";
import { Switch, Route, Router as Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import "./App.css";
import CssBaseline from "@material-ui/core/CssBaseline";
import Startup from "./Startup";
import DashboardPage from "./components/DashboardPage";
import { createMuiTheme, ThemeProvider } from "@material-ui/core";
// import useMediaQuery from "@material-ui/core/useMediaQuery";

const history = createBrowserHistory();

function App() {
  const theme = createMuiTheme({
    palette: {
      // TODO: support dark mode -- this requires a compatible logo img
      // type: useMediaQuery("(prefers-color-scheme: dark)") ? 'dark' : 'light',
      primary: {
        main: "#5cdb5c",
      },
      secondary: {
        main: "#708090",
        contrastText: "#FFF",
      },
    },
  });

  return (
    <Startup>
      <ThemeProvider theme={theme}>
        <Router history={history}>
          <CssBaseline />
          <Switch>
            <Route path={"/"} component={DashboardPage} />
          </Switch>
        </Router>
      </ThemeProvider>
    </Startup>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js